import { gql } from "@apollo/client";

export const GET_SEGMENT_FILE_UPLOAD = gql`
  query GetSegmentFileUpload($segmentId: UUID!, $uploadId: ID!) {
    getSegmentFileUpload(segmentId: $segmentId, uploadId: $uploadId) {
      uploadStatus
      totalRows
      importedRows
      errorCount
      errorsTruncated
      errors {
        line
        column
        value
        detail
      }
      fileName
      fileSizeBytes
      startedAt
      completedAt
      createdAt
      updatedAt
    }
  }
`;
